// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2uIJq","col":"CardReaderDesc_col__2cKMq","label":"CardReaderDesc_label__3UMR0"};